module.exports = __webpack_public_path__ + "media/images/flags/32/Nauru-bb5c1d21d6a8634ad883e4debd852486.png";